module.exports = __webpack_public_path__ + "static/media/iotnet4.60994843.jpeg";